import '@mobiscroll/react/dist/css/mobiscroll.min.css'

import type { MbscDatepickerOptions } from '@mobiscroll/react'
import {
  Datepicker as MbscDatepicker,
  localeEnGB,
  localeNl,
  setOptions,
} from '@mobiscroll/react'
import dayjs from 'dayjs'
import i18n from 'i18next'

import { ErrorMessage, InputStyled } from '@/components/Input.tsx'
import { Label } from '@/components/Label.tsx'
import { Language } from '~common/constants.ts'

setOptions({
  locale: i18n.language === Language.nl ? localeNl : localeEnGB,
  theme: 'auto',
  themeVariant: 'light',
})

export const Datepicker = ({
  errorMessage,
  label,
  maxValue,
  minValue,
  name,
  placeholder,
  ...props
}: {
  name: string
  maxValue?: Date
  minValue?: Date
  placeholder?: string
  label?: string
  errorMessage?: string
} & MbscDatepickerOptions) => (
  <>
    <Label htmlFor={name}>{label}</Label>
    <MbscDatepicker
      inputProps={{ invalid: !!errorMessage, name }}
      controls={['date']}
      inputComponent={InputStyled}
      placeholder={placeholder}
      dateFormat="DD/MM/YYYY"
      returnFormat="iso8601"
      min={minValue || dayjs().subtract(120, 'years').toDate()}
      max={maxValue || dayjs().toDate()}
      circular={true}
      {...props}
    />
    {!!errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
  </>
)
